import Marquee from 'react-fast-marquee'

const marqueeItems = [
  'MARIDO DE ALUGUEL',
  'BALNEÁRIO CAMBORIÚ',
  'REPAROS E MANUTENÇÃO',
  'SERVIÇO GARANTIDO',
  'QUALIDADE E CONFIANÇA',
  'ATENDIMENTO PROFISSIONAL',
  'PREÇO JUSTO',
]

const MarqueeSection = () => (
  <section
    data-testid="marquee-section"
    className="py-10 md:py-12 bg-[#062B63] overflow-hidden relative"
    aria-hidden="true"
  >
    <div className="absolute top-0 left-0 w-full h-px bg-[#F2B300]/20" />
    <div className="absolute bottom-0 left-0 w-full h-px bg-[#F2B300]/20" />

    <Marquee speed={45} gradient={false}>
      {marqueeItems.map((item, i) => (
        <span
          key={i}
          className="mx-8 text-5xl md:text-6xl lg:text-7xl font-bold tracking-tighter font-outfit select-none whitespace-nowrap marquee-item"
        >
          {item}&nbsp;
          <span style={{ WebkitTextStroke: '0px', color: '#F2B300', fontSize: '0.7em' }}>
            ●
          </span>
          &nbsp;
        </span>
      ))}
    </Marquee>
  </section>
)

export default MarqueeSection
